var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.277,
    height: 23.3,
    viewBox: "0 0 26.277 23.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(-845.75 -373.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(846 374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M890.956,462.08h-2.871V459.3a1.3,1.3,0,0,0-1.3-1.3H872.992a1.3,1.3,0,0,0-1.3,1.3v2.779h-2.871A1.822,1.822,0,0,0,867,463.9v15.079a1.823,1.823,0,0,0,1.821,1.821h22.135a1.822,1.822,0,0,0,1.821-1.821V463.9a1.822,1.822,0,0,0-1.821-1.821Zm-17.7-2.519h13.272v2.519H873.253Zm-4.432,4.08h22.135a.263.263,0,0,1,.26.26v4.679h-7.888v-.7a1.3,1.3,0,0,0-1.3-1.3H877.75a1.3,1.3,0,0,0-1.3,1.3v.7h-7.888V463.9a.263.263,0,0,1,.26-.26Zm12.947,4.5v2.519H878.01v-2.519Zm9.188,11.1H868.821a.263.263,0,0,1-.26-.26V470.14h7.888v.779a1.3,1.3,0,0,0,1.3,1.3h4.278a1.3,1.3,0,0,0,1.3-1.3v-.779h7.888v8.839a.263.263,0,0,1-.26.26Zm0,0",
    transform: "translate(-867 -458)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.83b76a00.svg";
export { ForwardRef as ReactComponent };